import { BenefitsTableBlock } from 'cms-types'
import { type LoadableComponentProps } from 'ui'

import { BenefitsTableClient } from './BenefitsTableClient'

function BenefitsTable(props: LoadableComponentProps<BenefitsTableBlock>) {
  return <BenefitsTableClient {...props} />
}

export default BenefitsTable
BenefitsTable.loadable = true
